/**
 * Turning approver refs — role codes, position canonical codes — into words.
 *
 * The designer works against LIVE directories (the institution's role catalogue
 * and its position register), so while editing, every ref has a label. Instance
 * snapshots are older than the directories, though: a role renamed or retired
 * since the case started still has to render. The fallback keeps the raw code
 * readable (PRINCIPAL → "Principal") rather than blank, the same contract as
 * hierarchy-layout's humanizeUnitType — server data made readable while staying
 * recognisably the same token.
 */

export interface ApproverOption {
  value: string;
  label: string;
}

export function humanizeRefCode(code: string): string {
  if (code.length === 0) return code;
  const lower = code.replace(/[_-]/g, ' ').toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function refLabel(ref: string, options: readonly ApproverOption[]): string {
  return options.find((option) => option.value === ref)?.label ?? humanizeRefCode(ref);
}

export function refLabels(refs: readonly string[], options: readonly ApproverOption[]): string[] {
  return refs.map((ref) => refLabel(ref, options));
}
